import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { InventoryService } from 'src/app/services/inventory.service';
import { CreateProductDialogComponent } from '../create-product-dialog/create-product-dialog.component';
import { QuickMappingPopupComponent } from '../quick-mapping-popup/quick-mapping-popup.component';
import { takeUntil } from "rxjs/operators";
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { GridActionsService } from 'src/app/data-grid/grid-actions.service';
import { ShipyardService } from 'src/app/modules/shipyard/shipyard.service';
@Component({
  selector: 'app-unmapped-skus',
  templateUrl: './unmapped-skus.component.html',
  styleUrls: ['./unmapped-skus.component.scss']
})
export class UnmappedSkusComponent implements OnInit, OnDestroy {
  actions: any[];
  loading : boolean = false;
  unmappedSkuDetail: any;
  account: string;
  width: string;
  popUpToOpen: any;
  vendorList: any[];
  private destroy$ = new Subject<void>();
  loadExportProduct: boolean= false;
  loadingShipmentExport:boolean = false;
  shipmentDeductionAlertDetail:any[]=[];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<UnmappedSkusComponent>,
    private dialog : MatDialog,
    private inventoryservice : InventoryService,
    private snackBar: MatSnackBar,
    private gridActionService : GridActionsService,
    private inventoryService: InventoryService, 
    private shipyardService :ShipyardService
  ) {
    this.inventoryservice.updateUnmappedSkus$.pipe(takeUntil(this.destroy$)).subscribe((res)=>{
      if(res) this.getUnmappedSkuDetails();
    })
  }

  ngOnInit(): void {
    this.actions = this.data.actions || [
      { text: "Close" },
    ];
   // this.inventoryservice.typeaheadVendor('').subscribe(e => {this.vendorList=e})
    if(this.data.isWithSyncOff){
      this.getMappedWithSyncOff();
    } else if(!this.data.isItemStockWithNoMapping && !this.data?.nonDeductedShipmentCount){
      this.getUnmappedSkuDetails();
    }
    else if(this.data?.nonDeductedShipmentCount){
      this.getShipmentDeductionAlertDetail();
    }
  }

  getMappedWithSyncOff(){ 
    this.loading = true;
    this.inventoryservice.getMappedWithSyncOff().pipe(takeUntil(this.destroy$)).subscribe({
      next:(res:any)=>{
        if(this.data.isSkuNotFoundData){
          res=res.map((e)=>{
            return {
              type: e.accountType,
              skuCount: e.count,
              name: e.account
            }
          })
        }
        this.unmappedSkuDetail = res;
      },error:(err)=>{
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: err.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      },complete:()=>{
        this.loading = false;
      }
    });  
  }

  getUnmappedSkuDetails(){
    let api=this.inventoryservice.getUnmappedSkuDetail();    
    if(this.data.isSkuNotFoundData){
      api=this.inventoryservice.skuNotExistSellerDetails();
    }
    this.loading = true;
    api.pipe(takeUntil(this.destroy$)).subscribe({
      next:(res:any)=>{
        if(this.data.isSkuNotFoundData){
          res=res.map((e)=>{
            return {
              type: e.accountType,
              skuCount: e.count,
              name: e.account
            }
          })
        }
        this.unmappedSkuDetail = res;
      },error:(err)=>{
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: err.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      },complete:()=>{
        this.loading = false;
      }
    });  
  }

  action(e?) {
    this.dialogRef.close();
  }

  close(){
    this.dialogRef.close();
  }

  quickMappping(data){    
    if(data.skuCount <= '100') {
      this.popUpToOpen = QuickMappingPopupComponent;
      this.width = "1000px";
    } else{
      this.popUpToOpen = CreateProductDialogComponent;
      this.width = "616px"
    } 
    const dialog = this.dialog.open(this.popUpToOpen, {
      width: this.width,
      data: {
        accountSelected: data.name,
        channelType: data.type,
        skuCount: data.skuCount,
        vendorList: this.vendorList
      },
    });
    dialog
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe((e) => {
      });
  }

  exportUnmapedSku(item) {
    let api=this.inventoryservice.exportUmpappedSku(item.type,item.name);
    let name="unmapped-sku-list-download.csv";
    if(this.data.isWithSyncOff){
      api=this.inventoryservice.exportMappedWithSyncOffSku(item.name);
      name="mapped-sku-list-with-sync-off-download.csv";
    } else if(this.data.isSkuNotFoundData){
      api=this.inventoryservice.exportSkuNotExistSeller(item.name);
      name="sku-not-found-list-download.csv"
    }
    item.loadingTemplate = true;
    api.pipe(takeUntil(this.destroy$)).subscribe({
      next:(e:any)=>{
        this.downloadBlob(e.body, name)
      },error:(err)=>{
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: err.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      },complete:()=>{
        item.loadingTemplate = false; 
      }
    })
    
  }

  downloadBlob(blob, name) {
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = name;
    document.body.appendChild(link);
    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    document.body.removeChild(link);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  exportProducts() {
    this.loadExportProduct = true;
    this.inventoryService.ExportProducts().pipe(takeUntil(this.destroy$)).subscribe({
      next: (e) => {
      const snackbar = this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 1000000,
            horizontalPosition: 'center',
            data: {
              title: 'Preparing products for export...',
              action: 'Dismiss',
              type: 'info',
            },
          }
      );
      this.gridActionService.downloadBlob(e.body, snackbar, "products.csv");
      this.loadExportProduct = false;
    },
     error: (err) => {
      this.loadExportProduct = false;
     }
   });
  }
  
  getShipmentDeductionAlertDetail(){
    this.loading = true;
    this.shipyardService.ShipmentDeductionAlertDetail().pipe(takeUntil(this.destroy$)).subscribe({
      next:(res:any)=>{
        if(res){
          this.shipmentDeductionAlertDetail=res;
          this.shipmentDeductionAlertDetail.forEach((ele)=>{ele.type= "Amazon"})
          this.loading = false;
        }
      },error:(err)=>{
        this.loading = false;
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: err.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      },complete:()=>{
        this.loading = false;
      }
    });  
  }

  exportDeductShipment(item?) {
    this.loadingShipmentExport = true;
    this.shipyardService.ShipmentDeductionAlertDetailExport(item.account).pipe(takeUntil(this.destroy$)).subscribe({
      next: (e) => {
      const snackbar = this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 1000000,
            horizontalPosition: 'center',
            data: {
              title: 'Preparing shipment for export...',
              action: 'Dismiss',
              type: 'info',
            },
          }
      );
      this.gridActionService.downloadBlob(e.body, snackbar, "shipment.csv");
      this.loadingShipmentExport = false;
    },
     error: (err) => {
      this.loadingShipmentExport = false;
     }
   });
  }
}
